"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
exports.CustomizerContext = React.createContext({
    customizations: {
        inCustomizerContext: false,
        settings: {},
        scopedSettings: {}
    }
});
//# sourceMappingURL=CustomizerContext.js.map


//////////////////
// WEBPACK FOOTER
// ./~/@uifabric/utilities/lib-commonjs/customizations/CustomizerContext.js
// module id = 524
// module chunks = 0